import { render, staticRenderFns } from "./ExpiredLinkView.vue?vue&type=template&id=42dbe12e"
import script from "./ExpiredLinkView.vue?vue&type=script&lang=js"
export * from "./ExpiredLinkView.vue?vue&type=script&lang=js"
import style0 from "./ExpiredLinkView.vue?vue&type=style&index=0&id=42dbe12e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports